import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["pwField", "pwVerField", "mixText", "repeatText", "sequenceText", "lengthText"]

  passwordValidate() {
    const check = []
    if (this.checkLength(this.pwFieldTarget.value)){
      check.push(true)
      this.textSetValid(this.lengthTextTarget, true)
    } else {
      check.push(false)
      this.textSetValid(this.lengthTextTarget, false)
    }

    if (this.checkMix(this.pwFieldTarget.value)) {
      check.push(true)
      this.mixTextTarget.classList.toggle("text-danger", false)
      this.textSetValid(this.mixTextTarget, true)
    } else {
      check.push(false)
      this.textSetValid(this.mixTextTarget, false)
    }

    if (this.checkRepeat(this.pwFieldTarget.value)) {
      check.push(false)
      this.textSetValid(this.repeatTextTarget, false)
    } else {
      check.push(true)
      this.textSetValid(this.repeatTextTarget, true)
    }

    if (this.checkSequence(this.pwFieldTarget.value)) {
      check.push(false)
      this.textSetValid(this.sequenceTextTarget, false)
    } else {
      check.push(true)
      this.textSetValid(this.sequenceTextTarget, true)
    }

    if (check.includes(false)) {
      this.fieldSetValid(this.pwFieldTarget, false)
    } else {
      this.fieldSetValid(this.pwFieldTarget, true)
    }
  }

  checkMix(check) {
    return (new RegExp(/\w/, "gi").test() && new RegExp(/\d/, "gi").test(check))
  }

  checkRepeat(check) {
    return (new RegExp(/(.)\1\1/, "g").test(check)) 
  }

  checkSequence(check) {
    if (new RegExp(/(zxc|xcv|cvb|vbn|bnm|nm,|m,\.|,\.\/)/, "gi").test(check)){
      return true
    } else if (new RegExp(/(\/\.,|\.,m|,mn|mnb|nbv|bvc|vcx|cxz)/, "gi").test(check)) {
      return true
    } else if (new RegExp(/(012|123|234|345|456|567|678|789|890)/, "gi").test(check)) {
      return true
    }else if (new RegExp(/(098|987|876|765|654|543|432|321|210)/, "gi").test(check)) {
      return true
    } else if (new RegExp(/(qwe|wer|ert|rty|tyu|yui|uio|iop|op\[|p\[\]|\[\]\\)/, "gi").test(check)) {
      return true
    } else if (new RegExp(/(asd|sdf|dfg|fgh|ghj|hjk|jkl|kl;|l;)/, "gi").test(check)) {
      return true
    } else if (new RegExp(/(\\\]\[|\]\[p|\[po|poi|oiu|iuy|uyt|ytr|tre|rew|ewq)/, "gi").test(check)) {
      return true
    } else if (new RegExp(/(;l|;lk|lkj|kjh|jhg|hgf|gfd|fds|dsa)/, "gi").test(check)) {
      return true
    } else if (new RegExp(/(zyx|yxw|xwv|wvu|vut|uts|tsr|srq|rqp|qpo|pon|onm|nml|mlk|lkj|kji|jih|ihg|hgf|gfe|fed|edc|dcb|cba)/, "gi").test(check)) {
      return true
    } else if (new RegExp(/(abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz)/, "gi").test(check)) {
      return true
    } else {
      return false
    }
  }

  checkLength(check) {
    return (check.length > 13)
  }

  checkMatch() {
    if (this.pwFieldTarget.value == this.pwVerFieldTarget.value && this.pwFieldTarget.classList.contains('is-valid')) {
      this.fieldSetValid(this.pwVerFieldTarget, true)
    } else {
      this.fieldSetValid(this.pwVerFieldTarget, false)
    }
  }

  textSetValid(requirementText, isValid) {
    requirementText.classList.toggle('text-success', isValid)
    requirementText.classList.toggle('text-danger', !isValid)
  }

  fieldSetValid(field, isValid) {
    field.classList.toggle('is-valid', isValid)
    field.classList.toggle('is-invalid', !isValid)
  }
}